import React, {ButtonHTMLAttributes, forwardRef, ReactNode} from 'react';

import {TooltipProps} from 'react-tooltip';

import {Tooltip} from '../Tooltip';

import {ButtonInner, ButtonRoot} from './styled';

/* Example
 *  <IconButton
 *   onClick={console.log}
 *   label="Удалить"
 *   icon={<Icon source={TestIcon} width={16} height={16} />}
 *  />
 * */

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    label?: string;
    labelPlace?: TooltipProps['place'];
    icon: ReactNode;
    hoverIndication?: boolean;
    type?: 'button' | 'submit' | 'reset';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    ({label, labelPlace, icon, hoverIndication, type = 'button', ...otherProps}, ref) => (
        <>
            {label && <Tooltip place={labelPlace} />}
            <ButtonRoot
                ref={ref}
                hoverIndication={hoverIndication}
                type={type}
                {...otherProps}
                data-tip={label}
            >
                <ButtonInner>{icon}</ButtonInner>
            </ButtonRoot>
        </>
    ),
);

interface IconButtonUniqueIdProps extends IconButtonProps {
    tooltipId: string;
}

const additionalStyles = `
    text-align: left;
    max-width: 250px;
    border-radius: 8px;
    opacity: 1 !important;
`;

export const IconButtonUniqueId = forwardRef<HTMLButtonElement, IconButtonUniqueIdProps>(
    (
        {label, tooltipId, labelPlace, icon, hoverIndication, type = 'button', ...otherProps},
        ref,
    ) => (
        <>
            {label && (
                <Tooltip
                    id={tooltipId}
                    place={labelPlace ?? 'bottom'}
                    backgroundColor="white"
                    textColor="#111111"
                    additionalStyles={
                        additionalStyles + 'box-shadow: 0px 0px 6px rgba(116, 116, 116, 0.3);'
                    }
                />
            )}
            <ButtonRoot
                ref={ref}
                hoverIndication={hoverIndication}
                type={type}
                {...otherProps}
                data-tip={label}
                data-for={tooltipId}
            >
                <ButtonInner>{icon}</ButtonInner>
            </ButtonRoot>
        </>
    ),
);
